import { Media } from 'media'
import { ComponentType } from 'react'
import { Container } from 'reactstrap'
import { BlogTagsDesktop } from './desktop'
import { BlogTagsMobile } from './mobile'

export const BlogTags: ComponentType<{ title?: string, subtitle?: string }> = ({ title, subtitle }) => (
    <Container>
        <Media at="xs">
            <BlogTagsMobile />
        </Media>
        <Media greaterThan="xs">
            <BlogTagsDesktop />
        </Media>
    </Container>
)